export const BROWSER = {
  CLICK: "click",
  MOUSE_DOWN: "mousedown",
  TOUCH_START: "touchstart"
};
